// routes/_app.artworks._index.tsx
import type { ClientLoaderFunctionArgs } from 'react-router'

const getClientModule = () => import('src/clientRoutes/_app.artworks')

export const handle = { name: 'artwork-home' }

export function loader() {
  return null
}

export async function clientLoader(args: ClientLoaderFunctionArgs) {
  const { loader } = await getClientModule()
  return loader(args)
}
clientLoader.hydrate = true

export default function Page() {
  return null
}
